<fieldset>
  <rask-icon-button
    [disabled]="disabled"
    (click)="toggle()"
    [icon]="icon"
    [label]="label">
  </rask-icon-button>
  @if (isOptions) {
    <div>
      @if (showMenu) {
        <div class="drop-down-menu" [ngClass]="alignmentClass">
          @for (option of options; track option) {
            <div>
              <rask-action-button (click)="optionClicked(option)">{{ option.value }}</rask-action-button>
            </div>
          }
        </div>
      }
    </div>
  }
  @if (isTemplate) {
    <div>
      @if (showMenu) {
        <div class="drop-down-menu" [ngClass]="alignmentClass">
          <ng-container *ngTemplateOutlet="template">
          </ng-container>
        </div>
      }
    </div>
  }
</fieldset>